export default "__VITE_ASSET__3znyHgiu__"